(() => {
  const disableClone = (group) => {
    group.setAttribute('aria-hidden', 'true');
    group.setAttribute('inert', '');
    group.setAttribute('role', 'presentation');
    group.setAttribute('data-nosnippet', '');
    group.setAttribute('data-studioos-runtime-clone', 'true');

    group.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((el) => {
      el.setAttribute('tabindex', '-1');
      el.setAttribute('aria-hidden', 'true');
      if (el.matches('form')) el.remove();
    });

    group.querySelectorAll('form').forEach((form) => form.remove());
    group.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
  };

  const ensureRuntimeClones = (root = document) => {
    root.querySelectorAll('.ez-product-marquee__track').forEach((track) => {
      const groups = track.querySelectorAll(':scope > .ez-product-marquee__group');
      if (!groups.length) return;

      groups.forEach((group, index) => {
        if (index > 0 || group.hasAttribute('aria-hidden')) disableClone(group);
      });

      if (groups.length === 1) {
        const clone = groups[0].cloneNode(true);
        clone.removeAttribute('data-studioos-marquee-source');
        disableClone(clone);
        track.appendChild(clone);
      }
    });

    root.querySelectorAll('.ez-brand-marquee__group[aria-hidden="true"]').forEach(disableClone);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ensureRuntimeClones());
  } else {
    ensureRuntimeClones();
  }

  document.addEventListener('shopify:section:load', (event) => ensureRuntimeClones(event.target));
})();
